// Paleta oficial dos gráficos da Rota do Dia, compartilhada por todas as telas
// que reaproveitam BarChart / LineChart / GraficoClienteLegenda.
export const FALLBACK_COLOR = "#FDBF00";

// Chaveada pelo grupoMaterialId / produtoId que vem do backend de roteirização.
export const idToColor = {
  1: "#FF5733",
  5: "#034EA2",
  8: "#900C3F",
  9: "#9ACA3C",
  10: "#FFC300",
  12: "#1ABC9C",
  13: "#DAF7A6",
  14: "#8E44AD",
  gov: "#1C2B58",
};

export const chartPalette = [
  idToColor[5],
  idToColor[1],
  idToColor[9],
  idToColor[12],
  idToColor[10],
  idToColor[14],
  idToColor[8],
  idToColor[13],
];

const normalize = (nome) =>
  (nome ?? "")
    .normalize("NFD")
    .replace(/\p{Diacritic}/gu, "")
    .trim()
    .toLowerCase();

// Telas sem o grupoMaterialId do backend (ex.: Carteira, que trabalha com a
// hierarquia de produto) resolvem a cor pelo nome do grupo.
//
// As cores vêm do mesmo padrão usado em FunnelV2/Negotiations/VolumeInNegotiation.
// Cimentos, Rejuntes e Impermeabilizantes foram conferidos na tela da Rota do Dia
// e batem com o id do backend (5, 9 e 14, respectivamente).
const grupoMaterialColors = {
  cimentos: idToColor[5], // #034EA2 - conferido
  rejuntes: idToColor[9], // #9ACA3C - conferido
  impermeabilizantes: idToColor[14], // #8E44AD - conferido
  colantes: idToColor[8], // #900C3F
  cales: idToColor[10], // #FFC300
  basicas: idToColor[12], // #1ABC9C ("basicas-granel" no Funil)
  concreto: "#00AEEF", // fora da paleta por id: só existe no mapa do Funil
  agregados: "#BDBDBD", // idem
};

export const getGrupoMaterialColor = (nome) => grupoMaterialColors[normalize(nome)];

// Distribui a paleta de forma estável para nomes fora do mapa (produtos, grupos novos),
// garantindo cores distintas em vez de todo mundo cair no FALLBACK_COLOR.
export const createColorAssigner = () => {
  const assigned = new Map();
  return (nome) => {
    const key = normalize(nome);
    if (!assigned.has(key)) assigned.set(key, chartPalette[assigned.size % chartPalette.length]);
    return assigned.get(key);
  };
};

// `chartColor` tem prioridade; senão cai no id do backend e, por fim, na cor padrão.
export const getChartColor = (item) => {
  if (item && typeof item === "object") return item.chartColor ?? idToColor[item.id] ?? FALLBACK_COLOR;
  return idToColor[item] ?? FALLBACK_COLOR;
};
